module.exports = __webpack_public_path__ + "static/jenny-findahl-9927da684210ab54e56e957990b73995.jpeg";